import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

AddrRevByPayor.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function AddrRevByPayor(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.addrRevByPayorMixTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="AddrRevByPayor"
            includeChart
        />
    );
}

export default AddrRevByPayor;
